const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 393.051 393.051",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF667C"
    },
    d: "M330.15,256.776l-133.624-32.194L62.901,256.776c-25.406,6.012-43.507,31.16-43.507,59.992v76.283 h354.263v-76.283C373.657,287.935,355.556,263.046,330.15,256.776z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56545F"
    },
    d: "M70.206,255.224v137.826H177.39c-53.721-57.147-69.947-116.364-74.667-145.648L70.206,255.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56545F"
    },
    d: "M290.327,247.337c-4.978,29.349-21.204,88.566-74.667,145.648h107.184V255.224L290.327,247.337z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEB490"
    },
    d: "M155.41,217.471v36.137c0,22.82,18.36,41.115,41.115,41.115l0,0c22.82,0,41.115-18.36,41.115-41.115 v-36.137L155.41,217.471L155.41,217.471z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EEB490"
    },
    cx: 129.422,
    cy: 137.568,
    r: 27.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EEB490"
    },
    cx: 263.628,
    cy: 137.568,
    r: 27.539
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FACCB4"
    },
    d: "M196.525,44.8L196.525,44.8c-38.788,0-70.465,31.418-70.465,70.465v51.329 c0,39.046,31.677,70.465,70.465,70.465l0,0c38.788,0,70.465-31.418,70.465-70.465v-51.329C266.99,76.283,235.313,44.8,196.525,44.8z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3851"
    },
    d: "M196.525,116.105c-82.812,0-147.523-29.867-147.523-68.137c0-2.909,2.327-5.236,5.236-5.236 s5.236,2.327,5.236,5.236c0,31.16,62.642,57.665,137.051,57.665s137.05-26.44,137.05-57.665c0-2.909,2.327-5.236,5.236-5.236 s5.236,2.327,5.236,5.236C344.048,86.238,279.337,116.105,196.525,116.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56545F"
    },
    d: "M338.812,42.731c-2.909,0-5.236,2.327-5.236,5.236c0,20.752-27.733,39.434-68.202,49.584L237.64,0 l-41.115,20.428L155.41,0l-27.669,97.487C87.208,87.337,59.475,68.719,59.475,47.968c0-2.909-2.327-5.236-5.236-5.236 s-5.236,2.327-5.236,5.236c0,38.271,64.711,68.137,147.523,68.137s147.523-29.867,147.523-68.137 C344.048,45.059,341.657,42.731,338.812,42.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF667C"
    },
    d: "M196.525,150.691l-72.081,31.677c0,69.172,72.081,84.622,72.081,84.622s72.081-15.451,72.081-84.622 L196.525,150.691z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f0d7072793a0a8bbe9b75d5ba2f85667.svg";
export { ForwardRef as ReactComponent };